$(document).ready(function () {
	// SEARCH
	var searchTime;
	$(document).on("keyup",'#JSsearch2', function(event) {
		if(event.keyCode == 13 && $('#JSsearch2').val() != ''){
			$(".JSsearch-button2").trigger("click");
		}
		if($('#elasticsearch').val() == 1){
			timer2();
		}else{	
			clearTimeout(searchTime);
			searchTime = setTimeout(timer2, 300);
		}
	});


	$('.JSSearchGroup2').change(function(){	timer2(); });

	function timer2(){
		var search_length = 2;
		if($('#elasticsearch').val() == 1){
			search_length = 0;
		}
		var search = $('#JSsearch2').val();
		if (search != '' && search.length > search_length) {
			$.post(base_url + 'ajax-search', {search:search}, function (response){
				if(response != ''){
					$('.JSsearch_list').remove();
					$('.AXsearch_content').html(response);
				}
			});
		} 
	}

	$('html :not(.JSsearch_list)').on("click", function() {
		$('.JSsearch_list').remove();
	});

	$('html :not(.AXsearch_articles)').on("click", function() {
		$('.AXsearch_articles').remove();
	});
});
